//xfl_math.js
//for some basic math function
//some basic function import from numberic.js
// import  {numeric as np} from './numeric_esm.js'
import './numeric.js'
import {Polyfit} from './polysolve-esm.js'

    const np = window.numeric;


    if(!Math.xround)Math.xround=function(v,n){//扩展xround功能 n位小数
        //四舍五入 n位小数
        　if (parseFloat(v).toString() == "NaN") {
            console.warn('Not a number,return ori value:' + v);
            return v;
        }
        let n_factor = 10**n;
        return Math.round(v*n_factor)/n_factor;
    };


    const ndim = function (arr){
        return (arr instanceof Array)?1+ndim(arr[0]):0;
    };
    //叉乘
    const cross = function (a,b){

        if(ndim(a)!=ndim(b)){
            throw new Error('Not the same size of cross operation' );
        };
        if(ndim(a)==1){//一维，直接乘和
            let s=0;
            a.forEach(function(v,idx){
                s+=a[idx]*b[idx];
            });
            return s;
        }else if(ndim(a)==2){
            if(a[0].length != b.length){
                throw new Error('a\'length not equal b[0]\'length');
            };
            let m = a.length,n=b.length,p=b[0].length;
            let c = new Array(m).fill(0).map(arr=>new Array(p).fill(0));
            for (let i = 0; i < m; i++) {
                for (let j = 0; j < p; j++) {
                    for (let k = 0; k <n; k++) {
                        c[i][j] += a[i][k] * b[k][j];
                    }
                }
            };
            return c;
        }else{
            throw new Error('dims >2 of cross operation' );
        }

    }

    //点乘
    const dot = function(a,b){
        if((ndim(a)!=ndim(b)) || (a.length != b.length)){
            throw new Error('Not the same size of Dot operation' );
        };
        return dot_(a,b);
        function dot_(a,b){
            let c = new Array(a.length).fill(0);
            if(a instanceof Array && !(a[0] instanceof Array)){//一维
                c.forEach(function(v,idx){
                    c[idx]=a[idx]*b[idx];
                });
            }else{//大于1维
                c.forEach(function(v,idx){
                    c[idx] = dot_(a[idx],b[idx]);
                })
            };
            return c;

        };
        function ndim(arr){
            return (arr instanceof Array)?1+ndim(arr[0]):0;
        }
    };

    //转置
    const transpose = function (matrix) {
        let result = new Array(matrix[0].length).fill(0).map(arr => new Array(matrix.length).fill(0));
        for (let i = 0; i < result.length; i++) {
            for (let j = 0; j < result[0].length; j++) {
                result[i][j] = matrix[j][i];
            }
        }
        return result;
    }

    //一维卷积
    const conv1 = function(arr,core,mode){
        mode = mode || 'full';
        if(ndim(core)!=1 && ndim(arr)!=1){
            throw new Error('Not 1 dim array');
        };
        let core_size = core.length;
        if(core_size%2==0 ){
            throw new Error('conlve core size should be even number');
        };
        switch(mode){
            case 'full':extent_size = core_size - 1;
                        res_size =arr.length + core_size - 1;
                        break;
            case 'same':
                        if(core_size[0]%2==0 || core_size[1]%2==0){
                            throw new Error('same mode conlve core size should be even number');
                        }
                        extent_size = (core_size-1)/2;
                        res_size =  [arr.length,arr[0].length];
                        break;
            case 'valid':extent_size = 0;
                        res_size = arr.length -core_size + 1;
                        break;
        };
        let new_arr = zeros(arr.length+extent_size*2);
        arr.forEach((v,idx)=>{new_arr[idx + extent_size] = v;});

        let res_arr = zeros(res_size);
        let s;
        for(let i=0;i<res_size;i++){
            s= 0;
            for(let j=0;j<core_size;j++){
                s += new_arr[i+j]*core[j];
            };
            res_arr[i] = s;
        }
        return res_arr;
    }

    //二维卷积
    const conv2 = function(arr,core,mode){
        mode = mode || 'full';
        if(ndim(core)!=2 && ndim(arr)!=2){
            throw new Error('Not 2 dim array');
        };
        let core_size = [core.length,core[0].length];

        let extent_size,res_size;
        switch(mode){
            case 'full':extent_size = [core_size[0]-1,core_size[1]-1];
                        res_size =[arr.length+core_size[0]-1,arr[0].length+core_size[1]-1];
                        break;
            case 'same':extent_size = [(core_size[0]-1)/2,(core[ 0].length-1)/2];
                        res_size =  [arr.length,arr[0].length];
                        if(core_size[0]%2==0 || core_size[1]%2==0){
                            throw new Error('same mode conlve core size should be even number');
                        }
                        break;
            case 'valid':extent_size = [0,0];
                        res_size = [arr.length -core_size[0] +1,arr[0].length-core_size[1]+1];
                        break;
        };

        let new_arr = array_extent(arr,extent_size,0);
        let res_arr = zeros(res_size[0],res_size[1]);
        let s;
        for(let i=0;i<res_size[0];i++){
            for(let j=0;j<res_size[1];j++){
                s=0;
                for(let c_i=0;c_i<core_size[0];c_i++){
                    for(let c_j=0;c_j<core_size[1];c_j++){
                        s += new_arr[i+c_i][j+c_j]*core[core_size[0]-1-c_i][core_size[1]-1-c_j];
                    }
                };
                res_arr[i][j] = s;
            }
        }

        return res_arr;
    }

    //扩展
    function array_extent(array,extent_size,extent_v){
        if(!(extent_size instanceof Array)){
            extent_size = [extent_size,extent_size];
        };
        const new_array = new Array(array.length + extent_size[0]*2).fill().map((v,idx,arr)=>{
            return new Array(array[0].length+extent_size[1]*2).fill(extent_v);
         });
         array.forEach((v,idx,arr)=>{
            v.forEach((v2,idx2,arr2)=>{
                new_array[extent_size[0]+idx][extent_size[1]+idx2]=v2;
            })
        });
        return new_array;
    }

    const zeros = function (row,col){
        if(!col){
            return new Array(row).fill(0);
        }
        return new Array(row).fill().map((val,idx,arr)=>{
            return new Array(col).fill(0);
        })
    }

    const array_like = function(arr){
        let n = ndim(arr);
        switch(n){
            case 1:return zeros(arr.length);
            case 2:return zeros(arr.length,arr[0].length);
            case 3:console.warn('Not support now');
            default:console.error('error'); return zeros(arr.length,arr[0].length);
        }

    }

    const array_copy = function(arr){
        let n = ndim(arr);
        switch(n){
            case 1:return [...arr];
            case 2:{
                let res = array_like(arr);
                for(let i=0,len_i=arr.length;i<len_i;i++){
                    for(let j=0,len_j=arr[i].length;j<len_j;j++){
                        res[i][j]=arr[i][j];
                    }
                };
                return res;
            };
            case 3:console.warn('Not support now');
            default:console.error('error'); return ['error'];
        }
    }
    /**pick count items from arr
     * @param  {Array}  arr 
     * @param  {Number} count
     */
    const rnd_pick = function(arr, count) {
        if(count<=0)return [];
        let shuffled = arr.slice(0), i = arr.length, min = i - count, temp, index;
        while (i-- > min) {//随机洗牌
            index = Math.floor((i + 1) * Math.random());
            temp = shuffled[index];
            shuffled[index] = shuffled[i];
            shuffled[i] = temp;
        }
        return shuffled.slice(min);
    }
    /**
     * @param  {Array} arr 1dim or 2dim
     * @param  {String} mode 'row' or 'col' when 2 dim array
     * @returns {Array} [max_v,max_pos]
     */
    const arr_max = function(arr,mode){
        let dim = ndim(arr);
        if(dim==1){
            let res = -Infinity;
            let pos;
            arr.forEach((v,i,a)=>{if(v>res){res = v;pos = i;}});
            return [res,pos];
        }else if(dim==2){
            let res=[];
            if(mode=='row' || mode == 0){
                arr.forEach((v)=>res.push(arr_max(v)));
                return res;
            }else if(mode =='col'|| mode == 1){
                let col_res;
                for(let i=0,len_i=arr[0].length;i<len_i;i++){
                    let col_min=-Infinity,min_index=0;
                    for(let j=0,len_j=arr.length;j<len_j;j++){
                        if(arr[j][i]>col_min){col_min=arr[j][i];min_index=j;}
                    };
                    col_res.push([col_min,min_index]);
                };
                return col_res;
            }else {
                let v_min=-Infinity,pos=[0,0];
                for(let i=0,len_i=arr.length;i<len_i;i++){
                    for(let j=0,len_j=arr[0].length;j<len_j;j++){
                        if(arr[i][j]>v_min){v_min=arr[i][j];pos=[i,j];}
                    };
                };
                return [v_min,pos];

            }
        }else{
        console.warn('wait to do 3 dim');
        return [undefined,0];}
    }

    const arr_min = function(arr,mode){//mode='row'  or 0  按行求最小值 ‘col' or 1 按列求最小值 undefined 全部最小值
        let dim = ndim(arr);
        if(dim==1){
            let res=Infinity,pos;
            arr.forEach((v,i,a)=>{if(v<res){res = v;pos = i;}});
            return [res,pos];
        }else if(dim==2){
            let res=[];
            if(mode=='row' || mode == 0){
                arr.forEach((v)=>res.push(arr_min(v)));
                return res;
            }else if(mode =='col'|| mode == 1){
                let col_res;
                for(let i=0,len_i=arr[0].length;i<len_i;i++){
                    let col_min=Infinity,min_index=0;
                    for(let j=0,len_j=arr.length;j<len_j;j++){
                        if(arr[j][i]<col_min){col_min=arr[j][i];min_index=j;}
                    };
                    col_res.push([col_min,min_index]);
                };
                return col_res;
            }else {
                let v_min=Infinity,pos=[0,0];
                for(let i=0,len_i=arr.length;i<len_i;i++){
                    for(let j=0,len_j=arr[0].length;j<len_j;j++){
                        if(arr[i][j]<v_min){v_min=arr[i][j];pos=[i,j];}
                    };
                };
                return [v_min,pos];

            }
        }else{
        console.warn('wait to do 3 dim');
        return [undefined,0];}
    }

    function flatten(arr) {
        let result = [];
        for (let i = 0; i < arr.length; i++) {
            if (Array.isArray(arr[i])) {  //判断是否是数组
                result = result.concat(flatten(arr[i]));  //自身递归与以前result合并，重新对result赋值
            } else {
                result.push(arr[i]);  //直接追加
            }
        }
        return result
     }

    const resize = function resize(arr,size){//size [n,~]内部数据支持~，目前仅支持二维
        if(size.length !=2){
            console.error('Not support now');
            throw new Error('size only support dimonsion 2');
        }
        if(ndim(arr)>1){
            arr = flatten(arr);
        };
        let whole_length = arr.length;
        let not_n_pos=[];
        let size_length=1;
        size.forEach((v,idx)=>{
            if(isNaN(Number(v))|| Number(v)<1){
                not_n_pos.push(idx);
            }else{
                size_length *= Number(v);
            }
        });
        switch(not_n_pos.length){
            case 0:not_n_pos.push(size.length -1);size_length /= size[size.length-1];
            case 1:size[not_n_pos[0]] = Math.floor(whole_length/size_length);break;
            case 2:
            default:throw new Error('bad resize parameters');
        }


        switch(size.length){
            case 2:{
                let res = [];
                for(let i=0;i<size[0];i++){
                    let this_array=[];
                    for(let j=0;j<size[1];j++){
                        let pos = i*size[1]+j;
                        this_array.push(arr[pos]);
                    };
                    res.push(this_array);
                };
                return res;
            }
            case 3:
            default:console.warn('Not support now');
        }


    }
    const arr_mean = function(arr,dim){//dim 0 row 1 col
        function arr_mean_1(arr){
            let s =0;
            arr.forEach((v)=>{s+=v*1});
            return s/arr.length;
        }
        switch(ndim(arr)){
            case 1:return arr_mean_1(arr);
            case 2:{
                if(dim==undefined){
                    let s=0,i_len = arr.length,j_len=arr[0].length;
                    for(let i=0;i<i_len;i++){
                        for(let j=0;j<j_len;j++){
                            s += arr[i][j];
                        }
                    };
                    return s/(i_len*j_len);
                }else if(dim==0 || dim == 'row'){
                    let res = new Array(arr.length);
                    arr.forEach((v,idx,arr)=>{
                        res[idx] = arr_mean_1(v);
                    })
                    return res;
                }else{

                    let s=0,i_len = arr.length,j_len=arr[0].length;
                    let res = new Array(j_len);
                    for(let j=0;j<j_len;j++){
                        let s_col=0;
                        for(let i=0;i<i_len;i++){
                            s_col += arr[i][j];
                        };
                        res[j] = s_col/i_len;
                    };
                    return res;
                }
            };
            case 3:console.log('Not support now');
            default:throw new Error('Not support dimension >2');
        }
    };
    const arr_std = function(arr_){//计算数据的标准偏差
        let arr = [...arr_.flat()];
        let mean = arr_mean(arr);
        let s = 0;
        arr.map(v=>{
            s +=(v - mean)**2
        });
        return Math.sqrt(s/arr.length);
    }
    const dot_distance = function(pos1,pos2){
        let res = 0;
        for(let i in pos1){
            if(pos2[i]==undefined){console.warn('Bad pos distance parameters?you need check it');continue;}
            res += (pos1[i]-pos2[i])**2;
        };
        return Math.sqrt(res);
    };
    
    /** pick rect array from whole at center 
     * @param  {array} arr
     * @param  {array} center position
     * @param  {array} radius radius from center
     */
    const arr_rect_pick = function(arr,center,radius){
        if(ndim(arr)!=2){
            console.error('just support 2 dimmension now');
            return 
        };
        let s_start = np.max(np.floor(np.sub(center,radius)),[0,0]);
        let s_end = np.min(np.ceil(np.add(center,radius)),[arr.length,arr[0].length]);
        let rect = [],row;
        for(let i=s_start[0];i<s_end[0];i++){
            row = []
            for(let j=s_start[1];j<s_end[1];j++){
                row.push(arr[i][j]);
            };
            rect.push(row);
        };
        return rect;
    }
    const arr_circle_pick = function(arr,center,radius){//center must be array
        if(ndim(arr) !=2){
            console.log('bad oprate?');
            return [[],[]];
        };
        let data_v = [];
        let data_index = [];
        for(let i=0,len_i= arr.length;i<len_i;i++){
            let row_data = arr[i];
            for(let j=0,len_j=row_data.length;j<len_j;j++){
                if(dot_distance([i,j],center)<=radius){
                  data_index.push([i,j]);
                  data_v.push(arr[i][j])
                }
            }
        };
        return [data_index,data_v];
    };
    const arr_index_pick = function(arr,index){
        //todo 此函数谨慎使用, 仅完成一维提取 二维提取
        let res = [];
        let N = ndim(arr),N1 = ndim(index);
        if(N < N1){console.warn('bad index array dimension !');return [];};

        switch(N1){
            case 1:{
                index.map(v=>{res.push(arr[v])});
                return res;
            };
            case 2:{
                if(index[0].length>2){
                    console.warn('bad index array dimension');
                    return [];
                }
                index.map(v=>{
                    res.push(arr[v[0]][v[1]])
                });
                return res;
            };
            case 3:{
                console.warn('Not surpport 3 dimension array now');
                return []
            }
        }
    };

    //
    /** 矩阵减
     * @param  {array} arr
     * @param  {array or number} sub_v
     */
    const arr_sub = function(arr,sub_v){
        let res = array_like(arr);
        if(typeof(sub_v)=='number'){
            switch(ndim(arr)){
                case 1:arr.map((v,idx)=>{res[idx]=v - sub_v});break;
                case 2:for(let i=0,len_i=arr.length;i<len_i;i++){
                    for(let j=0,len_j=arr[i].length;j<len_j;j++)res[i][j]=arr[i][j]-sub_v;
                    };
                    break;
                case 3:
                    for(let i=0,len_i=arr.length;i<len_i;i++){
                        for(let j=0,len_j=arr[i].length;j<len_j;j++){
                            for(let k=0,len_k=arr[i].length;k<len_k;k++)
                            res[i][j][k]=arr[i][j][k]-sub_v;
                        }
                    };
                        break;
                default:console.error('not support 4 dimensons');
            };
            return res;
        }else{
            if(ndim(arr)!=ndim(sub_v)){
                console.error('arr and sub_v are not the same');
                return res;
            };
            switch(ndim(arr)){
                case 1:arr.map((v,idx)=>{res[idx]=v - sub_v[idx]});break;
                case 2:for(let i=0,len_i=arr.length;i<len_i;i++){
                    for(let j=0,len_j=arr[i].length;j<len_j;j++)res[i][j]=arr[i][j]-sub_v[i][j];
                    };
                    break;
                case 3:
                    for(let i=0,len_i=arr.length;i<len_i;i++){
                        for(let j=0,len_j=arr[i].length;j<len_j;j++){
                            for(let k=0,len_k=arr[i].length;k<len_k;k++)
                            res[i][j][k]=arr[i][j][k]-sub_v[i][j][k];
                        }
                    };
                        break;
                default:console.error('not support 4 dimensons');
            };
            return res;

        }
        
        
         
    }

    /** 矩阵加
     * @param  {} arr 矩阵
     * @param  {} add_v 加的值
     */
    const arr_add = function(arr,add_v){
        if(typeof(add_v)=='number'){
            return arr_sub(arr,-add_v);  
        }else{
            return arr_sub(arr,dot(arr,-1));
        }
                 
    }

    /** 矩阵乘
     * @param  {} arr 矩阵
     * @param  {} multi_v 乘的值
     */
    const arr_multiply = function(arr,multi_v){
        let res = array_like(arr);
        switch(ndim(arr)){
            case 1:arr.map((v,idx)=>{res[idx]=v + multi_v});break;
            case 2:for(let i=0,len_i=arr.length;i<len_i;i++){
                for(let j=0,len_j=arr[i].length;j<len_j;j++)res[i][j]=arr[i][j]*multi_v;
                };
                break;
            case 3:
                for(let i=0,len_i=arr.length;i<len_i;i++){
                    for(let j=0,len_j=arr[i].length;j<len_j;j++){
                        for(let k=0,len_k=arr[i].length;k<len_k;k++)
                        res[i][j][k]=arr[i][j][k] * multi_v;
                    }
                };
                    break;
            default:console.error('not support 4 dimensons');
        };
        return res;        
    }
    
    /**矩阵除
     * @param  {array} arr
     * @param  {number} div_v
     */
    const arr_divide = function(arr,div_v){
        if(div_v==0){console.warn('divie value is 0,all will be Infinity')};
        if(typeof(div_v)=='number'){
            return arr_multiply(arr,1/div_v);
        }else{
            if(arr.length>50){console.warn('big size of arr,you should use a better way to caclc it')}
            return dot(arr,1/div_v);
        }
        
    }
    /**随机矩阵
     * @param  {Array} shape  行列
     * @param  {Number|Array|undefined} v_min  range if Array,number will be min,undefined will be 0~1
     * @param  {Number|undefined} v_max  max
     * @return {Array}
     */
    const arr_rnd = function(shape,v_min,v_max){
        if(!Array.isArray(shape))shape=[shape];
        let res = np.random(shape);
        if(v_min==undefined)return res;
        if(Array.isArray(v_min)){
            let rng_dim = ndim(v_min);
            if(rng_dim===1){//整体范围定义
                v_max = v_min[1];v_min=v_min[0];
                return np.add(np.mul(res,v_max-v_min),v_min);      
            }else if(rng_dim===2 && v_min.length === shape[0]){ //每一个都有范围
                for(let i=0;i<shape[0];i++){
                    res[i] = (v_min[i][1] - v_min[i][0])*res[i] + v_min[i][0];
                }
            }else{
                console.error('bad par while len of range not equal shape[0]')
            }
        }
        return res;
        
    }
    /**
     * 取数组最后N位
     * @param  {array} arr 目标数组
     * @param  {Number} N 取的位数
     * @return {Array}
     */
    const arr_last = function(arr,N){
        if(N>arr.length){
            // console.warn('arr last length bigger than length of arr');
            return arr.slice(0,arr.length);
        }else{
            return arr.slice(arr.length-N,arr.length);
        }
    }
    /**
     *  计算小矩阵与大矩阵仿射的位置
     * @param  {} s_arr 小矩阵，二维
     * @param  {} b_arr 大矩阵，二维
     */
    const arr_pad_pos = function(s_arr,b_arr){

    }
    
    /**
     * notice: shift the ori Array fft fftshift
     * @param  {Array} d
     */
    const half_shift =function (d){

        let half_len = Math.floor(d.length/2);
        let temp;
        for(let i=0;i<half_len;i++){
            temp = d[i];
            d[i] = d[i+half_len];
            d[i+half_len] = temp;
        };
        for(let i=0;i<half_len;i++){
            temp = d[i];
            d[i] = d[d.length-1-i];
            d[d.length-1-i] = temp;
        };
        return d;
    }
    /** 计算向量夹角
     * @param  {Object} pos1 {x,y}点1或者向量1
     * @param  {Object} pos2 {x,y}点2或者向量2
     * @param  {Object|null} pos3 {x,y} or undefined 点3或者无
     */
    const vector_angle = function(pos1,pos2,pos3){
         let v1 = pos1,v2 = pos2;
         if(pos3){
             v1 = {x:pos2.x-pos1.x,y:pos2.y-pos1.y};
             v2 = {x:pos3.x-pos1.x,y:pos3.y-pos1.y};
         };
        //  let v1_b_v2 = v1.x*v2.x+v1.y*v2.y;
        //  let v1_abs = Math.sqrt(v1.x**2+v1.y**2);
        //  let v2_abs = Math.sqrt(v2.x**2+v2.y**2);
        //  let angle = Math.acos(v1_b_v2/(v1_abs*v2_abs))/Math.PI*180;
         let v1_angle = Math.atan2(v1.y,v1.x);
         let v2_angle = Math.atan2(v2.y,v2.x);
         return (v2_angle - v1_angle)/Math.PI*180;
    }

    const interplate = function(P1,P2,rate){
        if(Array.isArray(P1)){
            return P1.map((v,idx)=>(v+(P2[idx]-v)*rate))
        }else{
            return P1 + (P2 - P1) * rate;
        }
    }
    export {
        Polyfit,arr_last,
        np,half_shift,interplate,
        ndim,cross,dot,transpose,conv1,conv2,zeros,array_like,rnd_pick,arr_max,arr_min,arr_rnd,
        flatten,resize,arr_mean,dot_distance,arr_circle_pick,arr_rect_pick,arr_index_pick,arr_std,arr_sub,arr_add,arr_multiply,arr_divide,vector_angle,

    }
